import { useState, useEffect } from "react";

/**
 * Generic countdown hook — takes any future Date and returns {days, hours, minutes, seconds, over}.
 */
export function useCountdown(targetDate) {
  const calc = () => {
    const diff = Math.max(0, targetDate - new Date());
    if (diff === 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, over: true };
    return {
      days:    Math.floor(diff / 864e5),
      hours:   Math.floor((diff % 864e5) / 36e5),
      minutes: Math.floor((diff % 36e5) / 6e4),
      seconds: Math.floor((diff % 6e4) / 1e3),
      over: false,
    };
  };

  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return time;
}

/**
 * Shared countdown display box used on SA/VIC/NSW election guide pages.
 */
export function CountdownBox({ value, label, isDark }) {
  const bg = isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)";
  const border = isDark ? "rgba(255,255,255,0.10)" : "rgba(0,0,0,0.10)";
  const numColor = isDark ? "#FFFFFF" : "#0F172A";
  const labelColor = isDark ? "rgba(255,255,255,0.45)" : "rgba(15,23,42,0.5)";
  return (
    <div className="text-center" style={{ minWidth: 56 }}>
      <div
        className="flex items-center justify-center rounded-xl"
        style={{ background: bg, border: `1px solid ${border}`, padding: "8px 14px" }}
      >
        <span className="text-3xl sm:text-4xl font-black" style={{ fontFamily: "Outfit, sans-serif", color: numColor, lineHeight: 1 }}>
          {String(value).padStart(2, "0")}
        </span>
      </div>
      <span
        className="block mt-1 text-xs font-semibold uppercase tracking-widest"
        style={{ color: labelColor }}
      >
        {label}
      </span>
    </div>
  );
}
